import axios from "axios";
import config from "../Config.json";


const FetchChatHistory = async(data) => {
    try {
        const AuthToken = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = AuthToken;       
        try {
            const response = await axios.post(`${config.API_URL}/app/chathistory`, data,)
        return response
        } catch (error) {
            return []
        }
    } catch (error) {
        return error
    }
}

export default FetchChatHistory